module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container"
  }, [_c('div', {
    staticClass: "d-guides"
  }, [_c('StilGuides', {
    attrs: {
      "video-id": 'etaeiteazYM?start=67',
      "textForLink": "Guide: Se videoguide for Personalets alder og køn"
    }
  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-filters"
  }, [_c('div', {
    staticClass: "d-filters__filter",
    class: {
      'd-filters__filter--active': _vm.activeFilter === 0
    },
    on: {
      "click": function($event) {
        _vm.activeFilter = 0
      }
    }
  }, [_vm._v("Alle\n      "), _c('div', {
    staticClass: "d-pill"
  }, [_vm._v(_vm._s(_vm.usersWithVProps.length))])]), _vm._v(" "), _c('div', {
    staticClass: "d-filters__filter",
    class: {
      'd-filters__filter--active': _vm.activeFilter === 1
    },
    on: {
      "click": function($event) {
        _vm.activeFilter = 1
      }
    }
  }, [_vm._v("Ikke udfyldte\n      "), _c('div', {
    staticClass: "d-pill"
  }, [_vm._v(_vm._s(_vm.unfilledUsers.length))])])]), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsersWithVProps), function(user, userIdx) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.gender),
        expression: "user.gender"
      }],
      staticClass: "timetal-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateUser(user, 'gender', $event.target.value)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "female"
      }
    }, [_vm._v("Kvinde")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "male"
      }
    }, [_vm._v("Mand")])])]), _vm._v(" "), _c('td', [_c('input', {
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": user.v_birthday
      },
      on: {
        "blur": function($event) {
          return _vm.updateUser(user, 'dob', $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.v_stil_stilling),
        expression: "user.v_stil_stilling"
      }],
      staticClass: "timetal-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "v_stil_stilling", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateUser(user, 'stil_stilling', $event.target.value)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "LA"
      }
    }, [_vm._v("Lærer")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "BH"
      }
    }, [_vm._v("Børnehaveklasseleder")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "PA"
      }
    }, [_vm._v("Pædagog")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "LE"
      }
    }, [_vm._v("Leder")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "AN"
      }
    }, [_vm._v("Andre med undervisningsopgaver")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "undtaget"
      }
    }, [_vm._v("Ingen undervisningsopgaver (ikke indberet)")])])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "italic"
  }, [_vm._v("Bemærk: Det er de personaler, som er ansat på skolen pr. 5. september 2022, der skal\n      indberettes.\n      "), _c('br'), _vm._v("Personale der ikke skal indberettes sættes til \"Ingen undervisningsopgaver (ikke indberet)\"")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "d-table__name"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Mand / Kvinde")]), _vm._v(" "), _c('th', [_vm._v("Fødselsdato")]), _vm._v(" "), _c('th', [_vm._v("Stilling")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-548b08fd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/GrundskoleIndberetningUsers.vue
// module id = 1922
// module chunks = 1